module.exports = __webpack_public_path__ + "media/native_steps_r1_animation_3.ae6e382b.mp4";